{
  "separatorName": "SEPARATOR",
  "sectionTitleName": "SECTION_TITLE",
  "GUEST_AVATAR_PATH": "/build/images/guest-avatar.svg",
  "FAVORITES_SELECTOR": "#navbar__favorites .ds-header__navbar__nav__link__pill",
  "ENQUIRIES_SELECTOR": "#navbar__enquiries .ds-header__navbar__nav__link__pill",
  "LEADS_SELECTOR": "#navbar__leads .ds-header__navbar__nav__link__pill",
  "MAX_HEADER_HEIGHT_MOBILE": 56,
  "guest": [
    {
      "name": "SECTION_TITLE",
      "label": "User"
    },
    {
      "url": "/login",
      "label": "Log in",
      "name": "login",
      "options": {
        "icon": "user",
        "desktopOnly": true,
        "tracking": {
          "section": "navbar_guest",
          "element": "log_in"
        }
      }
    },
    {
      "url": "/login/client",
      "label": "User login",
      "name": "login",
      "options": {
        "icon": "user",
        "mobileOnly": true,
        "tracking": {
          "section": "navbar_guest",
          "element": "log_in"
        }
      }
    },
    {
      "url": "/signup/client",
      "label": "User sign up",
      "name": "signup",
      "options": {
        "icon": "user-plus",
        "mobileOnly": true,
        "tracking": {
          "section": "navbar_guest",
          "element": "sign_up"
        }
      }
    },
    {
      "name": "SECTION_TITLE",
      "label": "Venue"
    },
    {
      "url": "/login/venue",
      "label": "Venue login",
      "name": "loginVenue",
      "options": {
        "icon": "login",
        "mobileOnly": true,
        "tracking": {
          "section": "navbar_guest",
          "element": "login_as_venue_manager"
        }
      }
    },
    {
      "url": "/page/list-your-venue",
      "label": "List your space",
      "name": "listYourVenue",
      "options": {
        "icon": "venue",
        "desktopOnly": true,
        "tracking": {
          "section": "navbar_guest",
          "element": "list_your_venue"
        }
      }
    },
    {
      "url": "/page/list-your-venue",
      "label": "List your space with us",
      "name": "listYourVenue",
      "options": {
        "icon": "venue",
        "mobileOnly": true,
        "tracking": {
          "section": "navbar_guest",
          "element": "list_your_venue"
        }
      }
    }
  ],
  "user": [
    {
      "url": "/account/enquiries/current",
      "label": "My enquiries",
      "name": "userEnquiries",
      "options": {
        "icon": "notification",
        "id": "navbar__enquiries",
        "tracking": {
          "section": "navbar_customer",
          "element": "my_enquiries"
        }
      }
    },
    {
      "url": "/favourites",
      "label": "Favourites",
      "name": "favorites",
      "options": {
        "icon": "fav",
        "id": "navbar__favorites",
        "tracking": {
          "section": "navbar_customer",
          "element": "favourites"
        }
      }
    },
    {
      "url": "/account/business?context=navbar",
      "label": "Join Tagvenue Business for free",
      "name": "corporateBusinessJoin",
      "options": {
        "button": true,
        "buttonLabelOnly": true,
        "icon": "briefcase",
        "dropdownLabel": "Tagvenue Business",
        "tracking": {
          "section": "navbar_customer",
          "element": "join_tagvenue_business_button",
          "trackVisible": true
        }
      }
    },
    {
      "url": "/account/business/dashboard",
      "label": "Tagvenue Business",
      "name": "corporateBusinessDashboard",
      "options": {
        "button": true,
        "buttonStyle": "subtle",
        "icon": "briefcase",
        "trailingIcon": "chevronRight",
        "tracking": {
          "section": "navbar_customer",
          "element": "see_tagvenue_business_button",
          "trackVisible": true
        }
      }
    },
    {
      "url": "/account/my-details",
      "label": "My account",
      "name": "account",
      "options": {
        "icon": "settings",
        "tracking": {
          "section": "navbar_customer",
          "element": "my_account"
        }
      }
    },
    {
      "url": "/account/logout",
      "label": "Log out",
      "name": "logout",
      "options": {
        "icon": "logout",
        "onclick": [
          "publishLogoutEvent"
        ],
        "tracking": {
          "section": "navbar_customer",
          "element": "log_out"
        }
      }
    }
  ],
  "manager": [
    {
      "name": "enquiries",
      "url": "/venue-cabinet/enquiries/all",
      "label": "Enquiries",
      "options": {
        "id": "navbar__enquiries",
        "icon": "notification",
        "tracking": {
          "section": "navbar_manager",
          "element": "my_enquiries"
        }
      }
    },
    {
      "name": "availability",
      "url": "/venue-cabinet/availability",
      "label": "Calendar",
      "options": {
        "icon": "calendar",
        "tracking": {
          "section": "navbar_manager",
          "element": "availability"
        }
      }
    },
    {
      "name": "venues",
      "url": "/venue-cabinet/venues",
      "label": "Venues",
      "options": {
        "icon": "venue",
        "tracking": {
          "section": "navbar_manager",
          "element": "edit_venues"
        }
      }
    },
    {
      "name": "reports",
      "url": "/venue-cabinet/insights/analytics",
      "label": "Reports",
      "options": {
        "icon": "barChart",
        "tracking": {
          "section": "navbar_manager",
          "element": "reports"
        }
      },
      "children": [
        {
          "name": "analytics",
          "url": "/venue-cabinet/insights/analytics",
          "label": "Analytics",
          "options": {
            "icon": "barChart",
            "tracking": {
              "section": "navbar_manager",
              "element": "reports"
            }
          }
        },
        {
          "name": "contacts",
          "url": "/venue-cabinet/contacts",
          "label": "Contacts and accounts",
          "options": {
            "icon": "people",
            "tracking": {
              "section": "navbar_manager",
              "element": "contacts_and_accounts"
            }
          }
        },
        {
          "name": "opportunities",
          "url": "/venue-cabinet/insights/performance",
          "label": "Opportunities",
          "options": {
            "icon": "lightbulb",
            "tracking": {
              "section": "navbar_manager",
              "element": "insights"
            }
          }
        },
        {
          "name": "reviews",
          "url": "/venue-cabinet/reviews",
          "label": "Reviews",
          "options": {
            "icon": "starEmpty",
            "tracking": {
              "section": "navbar_manager",
              "element": "reviews"
            }
          }
        },
        {
          "name": "payouts",
          "url": "/venue-cabinet/payouts",
          "label": "Payouts",
          "options": {
            "icon": "creditCard",
            "tracking": {
              "section": "navbar_manager",
              "element": "payouts"
            }
          }
        }
      ]
    },
    {
      "name": "christmasHub",
      "url": "/venue-cabinet/christmas-hub",
      "label": "Christmas Hub",
      "options": {
        "icon": "stars",
        "new": true,
        "tracking": {
          "section": "navbar_manager",
          "element": "christmas_hub"
        }
      }
    },
    {
      "name": "leads",
      "url": "/venue-cabinet/leads",
      "label": "Lead Hub",
      "options": {
        "id": "navbar__leads",
        "icon": "leadHub",
        "value": 0,
        "tracking": {
          "section": "navbar_manager",
          "element": "leads",
          "elementValue": ""
        }
      }
    },
    {
      "name": "SEPARATOR"
    },
    {
      "name": "settings",
      "url": "/venue-cabinet/company-details",
      "label": "Settings",
      "options": {
        "icon": "settings",
        "tracking": {
          "section": "navbar_manager",
          "element": "settings"
        }
      },
      "children": [
        {
          "name": "SECTION_TITLE",
          "label": "Personal settings"
        },
        {
          "name": "accountDetails",
          "url": "/venue-cabinet/my-account/details",
          "label": "Account details",
          "options": {
            "icon": "user",
            "tracking": {
              "section": "navbar_manager",
              "element": "settings",
              "elementValue": "Account details"
            }
          }
        },
        {
          "name": "notifications",
          "url": "/venue-cabinet/my-account/notifications",
          "label": "Notifications",
          "options": {
            "icon": "notification",
            "tracking": {
              "section": "navbar_manager",
              "element": "settings",
              "elementValue": "Notifications"
            }
          }
        },
        {
          "name": "aiAssistant",
          "url": "/venue-cabinet/my-account/ai-assistant",
          "label": "AI assistant",
          "options": {
            "icon": "stars",
            "tracking": {
              "section": "navbar_manager",
              "element": "settings",
              "elementValue": "AI assistant"
            }
          }
        },
        {
          "name": "SECTION_TITLE",
          "label": "Company settings"
        },
        {
          "name": "companyDetails",
          "url": "/venue-cabinet/company-details",
          "label": "Company details",
          "options": {
            "icon": "building",
            "tracking": {
              "section": "navbar_manager",
              "element": "company_details"
            }
          }
        },
        {
          "name": "teamMembers",
          "url": "/venue-cabinet/venues-managers",
          "label": "Team members",
          "options": {
            "icon": "people",
            "tracking": {
              "section": "navbar_manager",
              "element": "team_members"
            }
          }
        },
        {
          "name": "cateringOffers",
          "url": "/venue-cabinet/menus",
          "label": "Catering offers",
          "options": {
            "icon": "cuisine",
            "tracking": {
              "section": "navbar_manager",
              "element": "settings",
              "elementValue": "Catering offers"
            }
          }
        },
        {
          "name": "enquiryLabels",
          "url": "/venue-cabinet/enquiries/labels",
          "label": "Enquiry labels",
          "options": {
            "icon": "tag",
            "tracking": {
              "section": "navbar_manager",
              "element": "settings",
              "elementValue": "Enquiry labels"
            }
          }
        },
        {
          "name": "proPlans",
          "url": "/venue-cabinet/pro-plans",
          "label": "Pro plans",
          "options": {
            "icon": "award",
            "tracking": {
              "section": "navbar_manager",
              "element": "settings",
              "elementValue": "Pro plans"
            }
          }
        },
        {
          "name": "contactForm",
          "url": "/venue-cabinet/external-forms",
          "label": "Contact form",
          "options": {
            "icon": "clipboard",
            "tracking": {
              "section": "navbar_manager",
              "element": "settings",
              "elementValue": "Contact form"
            }
          }
        },
        {
          "name": "SECTION_TITLE",
          "label": "Templates"
        },
        {
          "name": "messageTemplates",
          "url": "/venue-cabinet/message-templates",
          "label": "Message templates",
          "options": {
            "icon": "messageChat",
            "tracking": {
              "section": "navbar_manager",
              "element": "settings",
              "elementValue": "Message templates"
            }
          }
        },
        {
          "name": "contractTemplates",
          "url": "/venue-cabinet/contract-templates",
          "label": "Contract templates",
          "options": {
            "icon": "fileAttachment",
            "tracking": {
              "section": "navbar_manager",
              "element": "settings",
              "elementValue": "Contract templates"
            }
          }
        },
        {
          "name": "invoiceTemplates",
          "url": "/venue-cabinet/invoice-templates",
          "label": "Invoice templates",
          "options": {
            "icon": "receiptCheck",
            "tracking": {
              "section": "navbar_manager",
              "element": "settings",
              "elementValue": "Invoice templates"
            }
          }
        }
      ]
    },
    {
      "name": "account",
      "url": "/venue-cabinet/my-account",
      "label": "My account",
      "options": {
        "icon": "myAccount",
        "tracking": {
          "section": "navbar_manager",
          "element": "my_account"
        }
      }
    },
    {
      "name": "help",
      "url": "/help/venue-faq",
      "label": "Help Centre",
      "options": {
        "icon": "info",
        "tracking": {
          "section": "navbar_manager",
          "element": "help_centre"
        }
      }
    },
    {
      "name": "logout",
      "url": "/venue-cabinet/logout",
      "label": "Log out",
      "options": {
        "icon": "logout",
        "onclick": [
          "publishLogoutEvent"
        ],
        "tracking": {
          "section": "navbar_manager",
          "element": "log_out"
        }
      }
    }
  ]
}